/**
 * AppTheme — Astryx `<Theme>` 루트 프로바이더.
 *
 * `<Theme>` 가 `<html>` 의 `data-astryx-theme` / `data-theme` 를 직접 동기화하므로
 * index.html 에 테마 속성을 하드코딩하지 않는다 (첫 페인트 깜빡임 방지용 인라인
 * 스크립트만 남긴다 — 같은 localStorage 키를 읽는다).
 */
import { useEffect, type ReactNode } from "react";
import { Theme } from "@astryxdesign/core/theme";
import { useThemeStore } from "../store/themeStore";
import { syncSystemBarsWithTheme } from "../native/insets";

export default function AppTheme({ children }: { children: ReactNode }) {
  const theme = useThemeStore((s) => s.theme);
  const mode = useThemeStore((s) => s.mode);

  // edge-to-edge 라 시스템 바 배경 = 앱 배경 — 바 아이콘 색을 테마 모드에 맞춘다
  // (라이트 모드에서 흰 아이콘이면 안 보인다). native 외 환경은 내부에서 no-op.
  useEffect(() => {
    void syncSystemBarsWithTheme(mode);
  }, [mode]);

  return (
    <Theme theme={theme} mode={mode}>
      {children}
    </Theme>
  );
}
